import React from 'react'
import cx from 'classnames'

import styles from './ReleaseNoteLayout.module.css'

import BackButton from '../../components/BackButton'
import Tips, { Tip } from '../../components/Tips'

const ReleaseNoteLayout = ({ children, ...rest }) => {
  return (
    <div className={styles.Container} {...rest}>
      {children}
    </div>
  )
}

export const ReleaseNoteMain = ({ children, ...rest }) => {
  return (
    <div className={styles.MainContent} {...rest}>
      <BackButton />
      <div className={styles.ReleaseNoteContent}>{children}</div>
    </div>
  )
}

export const ReleaseNoteSidebar = ({ children, ...rest }) => {
  return (
    <div className={styles.SidebarContent} {...rest}>
      <p>Manage</p>
      <div className={styles.ManageContainer}>{children}</div>
      <Tips title='How release notes work'>
        <Tip>Excite your customers with latest product updates</Tip>
        <Tip>Release notes can be viewed by your customers from the bot widget</Tip>
        <Tip>Categorise your release notes to effectively communciate the product updates</Tip>
      </Tips>
    </div>
  )
}

export const ReleaseNoteTitle = ({ className, children, ...rest }) => {
  return (
    <div className={cx(className, styles.Title)} {...rest}>
      {children}
    </div>
  )
}

export default ReleaseNoteLayout
